// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_op-0";